
<div v-if="isAfficher" class="box mb-2" :class="jel_getClassObject(content)">
  <!-- Un lien de retour spécifique a été attribué -->
  <b-link
    v-if="lienExiste"
    v-bind="jel_getLienBinding(content.lien)"
    class="lien-retour btnVide p-0"
  >
    <svg-icon
      icon-name="fleche-gauche"
      className="icone-fleche mySvg"
      :class="content.lien.cssIcone"
    ></svg-icon>
    <span class="graphik_semibold lien-retour pl-0 pt-sm-n1">{{
      content.texteRetour || $t('precedent')
    }}</span>
  </b-link>
  <!-- Ancien code pour la bouton retour utilisant le browser history (si aucun lien est défini) -->
  <button
    v-else-if="isAfficherLienPrecedent"
    data-precedent="precedent"
    class="lien-retour btnVide p-0"
    @click="jel_traiterRetour()"
  >
    <svg-icon icon-name="fleche-gauche" className="icone-fleche mySvg"></svg-icon>
    <span class="graphik_semibold textRetour pl-0 pt-sm-n1">{{
      content.texteRetour || $t('precedent')
    }}</span>
  </button>
</div>
